import './App.css';
/* src/App.svelte generated by Svelte v3.23.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "/web_modules/svelte/internal.js";

import Process from "./Process.js";
import Choose from "./Choose.js";
import Inbox from "./Inbox.js";
import { scanEmails } from "./processMail.js";

function create_if_block_3(ctx) {
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			button.textContent = "< Open another";
			attr(button, "id", "another");
			attr(button, "class", "svelte-djyhv0");
		},
		m(target, anchor) {
			insert(target, button, anchor);

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[6]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

// (130:2) {:else}
function create_else_block(ctx) {
	let t0;
	let t1;

	return {
		c() {
			t0 = text("Invalid state ");
			t1 = text(/*state*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*state*/ 1) set_data(t1, /*state*/ ctx[0]);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
		}
	};
}

// (128:52) 
function create_if_block_2(ctx) {
	let current;
	const inbox = new Inbox({ props: { data: /*data*/ ctx[3] } });

	return {
		c() {
			create_component(inbox.$$.fragment);
		},
		m(target, anchor) {
			mount_component(inbox, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inbox_changes = {};
			if (dirty & /*data*/ 8) inbox_changes.data = /*data*/ ctx[3];
			inbox.$set(inbox_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inbox.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inbox.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inbox, detaching);
		}
	};
}

// (126:35) 
function create_if_block_1(ctx) {
	let current;

	const process_1 = new Process({
			props: {
				loadState: /*loadState*/ ctx[1],
				progress: /*loadProgress*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(process_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(process_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const process_1_changes = {};
			if (dirty & /*loadState*/ 2) process_1_changes.loadState = /*loadState*/ ctx[1];
			if (dirty & /*loadProgress*/ 4) process_1_changes.progress = /*loadProgress*/ ctx[2];
			process_1.$set(process_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(process_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(process_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(process_1, detaching);
		}
	};
}

// (124:2) {#if state === 'choose'}
function create_if_block(ctx) {
	let current;
	const choose = new Choose({ props: { process: /*process*/ ctx[4] } });

	return {
		c() {
			create_component(choose.$$.fragment);
		},
		m(target, anchor) {
			mount_component(choose, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(choose.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(choose.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(choose, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let t0;
	let span;
	let t2;
	let current_block_type_index;
	let if_block1;
	let current;
	let if_block0 = /*state*/ ctx[0] !== "choose" && create_if_block_3(ctx);
	const if_block_creators = [create_if_block, create_if_block_1, create_if_block_2, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*state*/ ctx[0] === "choose") return 0;
		if (/*state*/ ctx[0] === "processing") return 1;
		if (/*state*/ ctx[0] === "list" || /*state*/ ctx[0] === "message") return 2;
		return 3;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			span = element("span");
			span.innerHTML = `<a href="https://github.com/josephg/mbox-viewer" class="svelte-djyhv0">View on Github</a>`;
			t2 = space();
			if_block1.c();
			attr(span, "class", "ghlink svelte-djyhv0");
			attr(div0, "class", "header svelte-djyhv0");
			attr(div1, "class", "container svelte-djyhv0");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			if (if_block0) if_block0.m(div0, null);
			append(div0, t0);
			append(div0, span);
			append(div1, t2);
			if_blocks[current_block_type_index].m(div1, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*state*/ ctx[0] !== "choose") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					if_block0.m(div0, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block1 = if_blocks[current_block_type_index];

				if (!if_block1) {
					if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block1.c();
				}

				transition_in(if_block1, 1);
				if_block1.m(div1, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block0) if_block0.d();
			if_blocks[current_block_type_index].d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let state = "choose";
	let loadState = null;
	let loadProgress = 0;
	let data = null;

	function getBuf(file) {
		return new Promise((resolve, reject) => {
				console.log("process", file);
				$$invalidate(2, loadProgress = 0);
				$$invalidate(1, loadState = `Reading file ${file.name}`);
				const reader = new FileReader();

				reader.onabort = () => {
					console.log("aborted");
				};

				reader.onerror = e => {
					console.error("error:", e);
					reject(e);
				};

				reader.onload = e => {
					// console.log('buffer', reader.result)
					resolve({
						buf: reader.result,
						name: file.name,
						lastModified: file.lastModified
					});
				};

				reader.onprogress = e => {
					// console.log('loadProgress', e.loaded)
					$$invalidate(2, loadProgress = e.loaded / file.size * 100);
				};

				reader.readAsArrayBuffer(file);
			});
	}

	async function process(files) {
		$$invalidate(0, state = "processing");

		// I could use Promise.all here but I want to load the files into memory one at a time.
		const bufs = []; // list of {buf, name, lastModified}

		for (const f of files) bufs.push(await getBuf(f));

		// const buf = await getBuf(file)
		$$invalidate(1, loadState = "Parsing emails");

		$$invalidate(2, loadProgress = 0);

		//.....
		$$invalidate(3, data = await scanEmails(bufs, (m, p) => {
			$$invalidate(1, loadState = m);
			$$invalidate(2, loadProgress = p * 100);
		}));

		$$invalidate(0, state = "list");
	}

	const click_handler = () => {
		$$invalidate(0, state = "choose");
		$$invalidate(3, data = null);
		$$invalidate(2, loadProgress = 0);
	};

	return [state, loadState, loadProgress, data, process, getBuf, click_handler];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;